export enum AddToCartRequestType {
    Package = "package", // Package Deal
    EventDate = "eventdate", // Event date
}

export interface AddToCartBaseRequest {
    type: AddToCartRequestType;
}

export type AddToCartRequestBase = {
    type: AddToCartRequestType;
    shipTicketsByMail: boolean;
    shipTicketsByETicket: boolean;
    deliveryMethodSet: boolean;
    supportsCCCondition: boolean;
    supportsMembershipCondition: boolean;
}

export type AddToCartPackageRequest = AddToCartRequestBase & {
    packageID: number;
    eventDates: AddToCartRequest[];
    
};

export type AddToCartRequest = AddToCartRequestBase & {
    eventDateID?: number; // This is used in old internet sale !!! In the new sale eventDateID find in BE side with ticketId
    ticketIDList?: string; // This TicketIDList used in old internet sale !!!
    ticketPrices: AddToCartTicketPriceRequest[]; 
};

export type AddToCartTicketPriceRequest = {
    ticketID?: number; // Just set in new internet sale 2024
    priceID: number;

    // Use only with prepaid card
    desiredAmount?: number;
    ticketQuantity?: number;
}
